module.exports = __webpack_public_path__ + "img/png01.3671e909.png";